import React from "react";

interface ErrorFallbackProps {
  error: Error;
  errorInfo?: React.ErrorInfo | null;
}

/**
 * Reusable error fallback UI component.
 * Used by ErrorBoundary to display error messages.
 */
export const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6 border border-red-200">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
            <svg
              className="h-6 w-6 text-red-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h1 className="text-2xl font-semibold text-gray-900 mb-2">
            Algo salió mal
          </h1>
          <p className="text-gray-600 mb-4">
            {error.message || "Ocurrió un error inesperado en la aplicación"}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="inline-flex cursor-pointer items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-lifeguards-blue hover:bg-lifeguards-light-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition"
          >
            Recargar página
          </button>
        </div>
      </div>
    </div>
  );
};

